<template>
  <div>
    <div class="checkbox" v-for="(label, index) in labels" :key="index">
      <label :for="label.id">
        <input
        type="checkbox"
        :name="tkey"
        :id="label.id"
        :value="label.value"
        v-model="valueArr"
        @focus="$emit('focus')"
        @blur="$emit('blur')">
        <i class="input-checkbox"></i>
        <span>{{label.name}}</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      valueArr: this.value
    }
  },
  props: {
    labels: {
      type: Array,
      default: () => {
        return []
      }
    },
    tkey: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    'valueArr': function (n, o) {
      this.$emit('input', { key: this.tkey, value: n })
      this.$emit('blur')
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/bulma/app.sass'

.checkbox
  margin-bottom: 15px
  display: block
  label
    // display: block
    // align-items: center
    width: 40px
    cursor: pointer
    input
      position: absolute
      opacity: 0
      visibility: hidden
      &:checked + .input-checkbox
        background: #fff
        border: 1px solid #ccc
        &:after
          position: absolute
          content: ""
          width: 12px
          height: 12px
          top: 2px
          left: 2px
          background: url('./assets/true.svg')
          background-size: contain
          background-position: center center
    .input-checkbox
      display: inline-block
      position: relative
      width: 16px
      height: 16px
      background: #fff
      border: 1px solid #ccc
      // border-radius: 50%
      vertical-align: -2px
    span
      margin-left: 5px
      +mobile
        font-size: 14px

</style>
